import getBrowseContext from './browse-context';
import getCallbacks from './callbacks';
import getDates from './dates';
import getInitialState from './initial-state';
import getRoute from './route';

import type {
  CallbackTranslations,
  MonthViewContext,
  MonthViewContextOptions,
} from './types';
import type { FareAttribute } from '@skyscanner-internal/global-components/types/fareAttributes';

const parseFareAttributes = (raw: string): FareAttribute[] =>
  Array.from(
    new Set(
      raw
        .split(',')
        .map((v) => v.trim())
        .filter(
          (v): v is FareAttribute => v === 'cabin-bag' || v === 'checked-bag',
        ),
    ),
  );

const normaliseChildrenAges = (
  childrenV2?: number | number[] | null,
): number[] => {
  if (childrenV2 == null) return [];
  return Array.isArray(childrenV2) ? childrenV2 : [childrenV2];
};

const createMonthViewContext = ({
  adultsV2,
  browse = {},
  cabinclass,
  childrenV2,
  destinationCityName,
  destinationEntityId,
  destinationId,
  destinationName,
  device,
  fareAttributes,
  inboundAlts,
  inboundDate,
  inboundDay,
  localisation,
  originEntityId,
  originId,
  originName,
  outboundAlts,
  outboundDate,
  outboundDay,
  preferDirects,
  stay,
  translations,
  tripType,
  viewId,
}: MonthViewContextOptions): MonthViewContext => {
  const callbackTranslations: CallbackTranslations = translations ?? {};

  return {
    localisation,
    route: getRoute(
      originId,
      originName,
      destinationId,
      destinationName,
      destinationCityName,
      destinationEntityId,
      originEntityId,
    ),
    dates: getDates(
      tripType,
      outboundDate,
      inboundDate,
      outboundDay,
      inboundDay,
    ),
    browse: {
      ...getBrowseContext(browse),
      viewId,
    },
    stay: {
      adults: stay?.adults ?? adultsV2 ?? null,
      childrenAges: normaliseChildrenAges(stay?.childrenAges ?? childrenV2),
    },
    callbacks: getCallbacks(
      originId,
      destinationId,
      tripType,
      adultsV2,
      cabinclass,
      childrenV2,
      callbackTranslations,
      outboundAlts,
      inboundAlts,
      fareAttributes ? parseFareAttributes(fareAttributes) : undefined,
    ),
    initialState: getInitialState(preferDirects),
    device,
  };
};

export default createMonthViewContext;
